import { ContentType, PublicationContentType } from '@app/entities/enums/multimedia/content-status-types.enum';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';
import { applyMixins } from '@shared/utils/utils';

import { AbstractMultimediaItem } from './multimedia.abstract.model';
import { Publication } from './publication.model';

export abstract class Image extends AbstractMultimediaItem {
  abstract contentType: PublicationContentType.IMAGE | ContentType.IMAGE;
  images!: { url: string; alt: string; caption?: string }[];
  thumbnail!: string;

  init(data: MSafeAny) {
    this.images = data?.images || [];
  }
}

export class ImagePublication extends Publication implements Image {
  contentType: PublicationContentType.IMAGE = PublicationContentType.IMAGE;
  images!: { url: string; alt: string; caption?: string }[];
  thumbnail!: string;
  init!: (data: MSafeAny) => void;

  constructor(data: MSafeAny) {
    super(data);
    this.init(data);
  }
}

applyMixins(ImagePublication, [Image]);
